import React from "react";

const Coupons = () => {
  return <div>Coupons</div>;
};

export default Coupons;
